<template>
  <wrap-container>
    <help-title title="Préstamos hipotecarios" />

    <help-list-container>
      <help-list-item tituloLista="Si sos cliente BBVA:">
        Podés verificar si tenés un préstamo preaprobado en
        <strong>Banca Online</strong>. Ingresá con tu DNI, Usuario y Clave
        Digital y seleccioná <strong>"Oferta preaprobada"</strong>.
      </help-list-item>
      <help-list-item tituloLista="Si todavía no sos cliente:">
        Podés simular tu cuota y solicitar online en 4 simples pasos.
        <custom-link
          label="Simulá tu cuota"
          href="https://simulatuprestamo.bbva.com.ar/prestamoPersonal/inicio.html#/prestamosPersonales/bienvenida"
        />
      </help-list-item>
      <help-list-item tituloLista="Más información:">
        Encontrá más información sobre préstamos hipotecarios en nuestro sitio
        <custom-link
          label="Ver más Información"
          href="https://www.bbva.com.ar/personas/productos/creditos-hipotecarios.html"
        />
      </help-list-item>
      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad. También podes acercarte a tu Sucursal.
        <p id="contactForm" @click="contacto">Quiero que me contacten</p>
        <div v-if="show">
          <br />
          <formulario-contacto />
        </div>
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import CustomLink from "@/components/core/CustomLink";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    CustomLink,
    FormularioContacto
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    contacto: function() {
      this.show = true;
    }
  }
};
</script>

<style>
#contactForm {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
</style>
